import type { UsbDevice } from '@posx/capacitor-usb-printer';
import { UsbPrinter } from '@posx/capacitor-usb-printer';
import { logError, logInfo } from '@/utils/logger';

let usbDeviceCache: UsbDevice[] | null = null;
let usbListenersReady = false;
let setupLock: Promise<void> | null = null;

export async function refreshUsbListeners() {
    try {
        const { devices } = await UsbPrinter.listDevices();
        usbDeviceCache = devices;
    } catch (e) {
        logError('refreshUsbListeners failed', { message: String(e) });
    }
}

export async function setupUsbListeners() {
    if (usbListenersReady) return;
    if (setupLock) return setupLock;
    setupLock = doSetupUsbListeners().finally(() => setupLock = null);
    return setupLock;
}

export function getUsbDevices() {
    return usbDeviceCache ?? [];
}

async function doSetupUsbListeners() {
    try {
        const { devices } = await UsbPrinter.listDevices();
        usbDeviceCache = devices;
        const attachedHandle = await UsbPrinter.addListener('deviceAttached', device => {
            logInfo('USB deviceAttached', { serialNumber: device.serialNumber, deviceId: device.deviceId });
            usbDeviceCache = [...(usbDeviceCache ?? []).filter(d => d.deviceId !== device.deviceId), device];
        });
        try {
            await UsbPrinter.addListener('deviceDetached', device => {
                logInfo('USB deviceDetached', { serialNumber: device.serialNumber, deviceId: device.deviceId });
                usbDeviceCache = (usbDeviceCache ?? []).filter(d => d.deviceId !== device.deviceId);
            });
            usbListenersReady = true;
        } catch (e) {
            try { await attachedHandle.remove(); } catch {}
            throw e;
        }
    } catch (e) {
        logError('setupUsbListeners failed', { message: String(e) });
    }
}
